import DataItem from "./DataItem";

export default DataItem;
